$(function(){

    // lazy solution for Switzerland's Extrawurst....
    // https://docs.djangoproject.com/en/2.0/topics/i18n/formatting/#limitations-of-the-provided-locale-formats
    const $localizeItems = $('[data-localize]');
    $localizeItems.each(function() {
        const value = $(this).data('localize').toLocaleString('de-CH');
        const unit = $(this).data('unit');
        $(this).html(`${value} ${unit}`);
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/localize.js